// extracted by mini-css-extract-plugin
export default {"component":"Employees_component__HBOhD","searchContainer":"Employees_searchContainer__pCW8i","actionContainer":"Employees_actionContainer__u4vhD"};